import tw from "twin.macro"
import { ContentDataProps } from "../../pages/[parent]"
import Card from "./card"

const Chronology = (props: ContentDataProps) => {
  const { contentData } = props

  return (
    <>
      {contentData && (
        <section>
          <div tw="max-w-screen-desktop-lg desktop-lg:mx-auto px-4 relative">
            {contentData.map((item: any, i: number) => {
              const cardProps = {
                deck: item.fields.deck,
                body: item.fields.body,
                caption: item.fields.caption,
                image_url: item.fields.image_url,
                image_preview: item.fields.image_preview,
              }
              return <Card key={i} {...cardProps} />
            })}
          </div>
        </section>
      )}
    </>
  )
}

export default Chronology
